<template>
  <current-user
    :userId="profileId"
  ></current-user>
</template>

<script>
import User from '@/components/User'

export default {
  computed: {
    profileId () {
      return this.$parent.currentUser.id
    }
  },

  components: {
    'current-user': User
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Profile.vue